<template>
    <BCard>
        <ValidationObserver ref="form">
            <BForm @submit.prevent="onSubmit">
                <BRow class="mb-2"> 
                    <BCol cols="12" md="4"> <h3><b>Datos generales</b></h3> </BCol>
                </BRow>
                <BRow> 
                    <TextInputValidated vsName="Name" :vsModel.sync="account.name" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Email" :vsModel.sync="account.email" vsLabel="email" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Phone" :vsModel.sync="account.phone" vsLabel="postal_code" vsMd="4" vsRequired vsRules="required"/>
                    <VSelectValidated vsName="Status" :vsModel.sync="account.status" :vsOptions="statusOptions" :vsReduce="status=>status.value"  vsLabel="label" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Sucursal" v-if="groupOptions && groupOptions.length>1" :vsModel.sync="account.groups" :vsOptions="groupOptions" vsLabel="name" vsMd="4" vsRequired vsRules="required" vsMultiple />

                </BRow>

                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Dirección</b></h3> </BCol>
                </BRow>
                <BRow> 
                    <TextInputValidated vsName="Address" :vsModel.sync="account.billing_address" vsRequired vsRules="required" vsLabel="postal_code" vsMd="4" />
                    <TextInputValidated vsName="City" :vsModel.sync="account.billing_city" vsLabel="City" vsMd="4" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Código postal" :vsModel.sync="account.billing_postal_code" vsLabel="Código postal" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Province" :vsModel.sync="account.billing_province_id" :vsOptions="provincesOptions" :vsReduce="province=>province.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="País" :vsModel.sync="account.billing_country_id" :vsOptions="countriesOptions" :vsReduce="country=>country.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                </BRow>

                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="6"> <h3><b>Datos de facturación</b></h3> </BCol>
                </BRow>
                <BRow>
                    <VSelectValidated vsName="Forma jurídica" :vsModel.sync="account.customer_type_id" :vsReduce="type=>type.id" :vsOptions="customerOptions"  vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="NIF" :vsModel.sync="account.billing_nif" vsLabel="NIF" vsMd="4" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Método de pago" :vsModel.sync="account.payment_method_id" :vsOptions="paymentMethodsOptions" :vsReduce="pay=>pay.id" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Cuenta bancaria" :vsModel.sync="account.iban" vsLabel="Cuenta bancaria" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated vsName="SWIFT/BIC" :vsModel.sync="account.swift_bic" vsLabel="SWIFT/BIC" vsMd="4" />
                    <CheckboxValidated v-if="showIsLegalEntity" vsName="is_legal_entity" :vsModel.sync="account.is_legal_entity" vsLabel="Es entidad legal" />
                    <TextInputValidated vsName="Razón social (Nombre)" :vsModel.sync="account.billing_name" vsLabel="Razón social (Nombre)" vsMd="4" vsRequired vsRules="required" />
                    <TextInputValidated v-show="showSurnames || !account.is_legal_entity" vsName="Razón social (Apellido 1)" :vsModel.sync="account.billing_first_surname" vsLabel="Razón social (Apellido 1)" vsMd="4" :vsRequired = "showSurnames || !account.is_legal_entity ? false : true" :vsRules="showSurnames || !account.is_legal_entity ? 'required' : ''"/>
                    <TextInputValidated v-show="showSurnames || !account.is_legal_entity" vsName="Razón social (Apellido 2)" :vsModel.sync="account.billing_second_surname" vsLabel="Razón social (Apellido 2)" vsMd="4"/>

                </BRow>
                <BRow class="mt-4 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Observaciones</b></h3> </BCol>

                </BRow>
                <BRow>
                    <TextareaValidated  vsName="Notes" :vsModel.sync="account.notes" />
                    <CheckboxValidated vsName="notif_email" :vsModel.sync="account.notif_email" vsLabel="Accept email notifications" />
                    <CheckboxValidated vsName="emit_face" :vsModel.sync="account.emit_face" vsLabel="Emitir factura electrónica" />

                </BRow>
                
                <BRow class="mt-4">
                    <BCol cols="12" md="4" >
                        <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                        <BButton variant="outline-secondary" type="reset" :to="{ name:'providers' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Cancel') }} </BButton>
                    </BCol>
                </BRow>

            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { BButton, BCard, BCol, BForm, BRow } from 'bootstrap-vue';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import { ValidationObserver } from 'vee-validate'
import axios from '@axios';
import router from '@/router';
import { addAccount } from '@/composables/accountService'
import popups from '@/hooks/popups';
import { getGroups } from '@/composables/groupService';

export default {
    components: { BForm, BRow, TextInputValidated, BCard, BCol, BButton, TextareaValidated, NumberInputValidated, VSelectValidated, ValidationObserver, DatepickerValidated, CheckboxValidated },
    setup() {
        const { successToast, errorToast } = popups()
        const form = ref(null);
        const countriesOptions = ref([])
        const provincesOptions = ref([])
        const customerOptions = ref([])
        const groupOptions = ref([])
        const paymentMethodsOptions = ref([])
        const statusOptions = [
            { label: 'Activo', value: 1 },
            { label: 'Inactivo', value: 0 },
        ]
        const showSurnames = ref(false)
        const showIsLegalEntity = ref(false)

        const account = ref({
            name:'',
            email:'',
            phone:'',
            notes:'',
            status:'',

            // Facturación
            bank_account:'',
            billing_name:'',
            billing_nif:'',
            billing_address:'',
            billing_city:'',
            billing_province_id:'',
            billing_postal_code:'',
            billing_country_id:'',
            equivalence_surcharge: false,
            customer_type_id: null,
            emit_face: false,
            is_legal_entity: null
        })
        const onSubmit = function(){
            form.value.validate().then(success => {
                if(success){
                    createAccount(account.value)
                }
            })
        }

        const createAccount = async function(account) {
            let response=await addAccount(account)

            if(response.data.success){
                successToast("Cuenta creada correctamente")
                router.push({ name: 'accounts' })
            } else {

                if (response.data.msg=="EXISTING_ACCOUNT") {
                    errorToast("Ya existe una cuenta con este NIF.")
                } else if (response.data.msg=="INVALID_CIF") {
                    errorToast("CIF inválido.")
                } else if (response.data.msg=="INVALID_DNI") {
                    errorToast("DNI inválido.")
                } 
                 else {
                    errorToast("Error creando cuenta")
                }
            }
        }

        const fetchGroups = async function () {
            let response = await getGroups()
            groupOptions.value = response.data.groups
        }
        
        fetchGroups()
        
        axios.get('countries').then(response => {
            countriesOptions.value = response.data
        })

        axios.get('provinces').then(response => {
            provincesOptions.value = response.data
        })

        axios.get('payment-methods').then(response => {
            paymentMethodsOptions.value = response.data
        })

        axios.get('customer-types').then(response =>  {
            customerOptions.value=response.data
        })


        watch(() => account.value.customer_type_id, () => {
            if (account.value.customer_type_id==1 || account.value.customer_type_id==2) {
                account.value.is_legal_entity = false
                showSurnames.value=true
            }
            if (account.value.customer_type_id==3 || account.value.customer_type_id==4) {
                showSurnames.value=false
                account.value.is_legal_entity = true
            }

            if (account.value.customer_type_id==5 || account.value.customer_type_id==6 || account.value.customer_type_id==7) {
                showIsLegalEntity.value=true
                account.value.is_legal_entity = false
            } else {
                showIsLegalEntity.value=false
            }
        })

        watch(() => account.value.is_legal_entity, () => {
            console.log(account.value.is_legal_entity)
        })

        return {
            onSubmit,
            form,
            countriesOptions,
            paymentMethodsOptions,
            provincesOptions,
            statusOptions,
            account,
            customerOptions,
            showSurnames,
            showIsLegalEntity,
            groupOptions
        }
    },
}
</script>

<style>

</style>